import React, { useEffect, useState } from "react";

const parts = (ms) => {
  const s = Math.max(0, Math.floor(ms / 1000));
  return [
    ["Days", Math.floor(s / 86400)],
    ["Hours", Math.floor((s % 86400) / 3600)],
    ["Mins", Math.floor((s % 3600) / 60)],
    ["Secs", s % 60],
  ];
};

export const Countdown = ({ to }) => {
  const target = new Date(to).getTime();
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  if (Number.isNaN(target)) return null;
  if (target - now <= 0) {
    return (
      <p data-testid="spotlight-countdown-live" className="mt-5 text-sm font-semibold text-emerald-300">
        Happening now
      </p>
    );
  }
  return (
    <div data-testid="spotlight-countdown" className="mt-5 flex gap-2.5">
      {parts(target - now).map(([label, v]) => (
        <div key={label} className="min-w-[64px] rounded-xl border border-amber-400/25 bg-amber-400/[0.06] px-3 py-2 text-center">
          <p data-testid={`countdown-${label.toLowerCase()}`} className="font-display text-2xl font-extrabold tabular-nums text-white">
            {String(v).padStart(2, "0")}
          </p>
          <p className="text-[10px] uppercase tracking-[0.16em] text-amber-200/70">{label}</p>
        </div>
      ))}
    </div>
  );
};
